import React, { useState, useEffect } from 'react';
import BlogCard from './BlogCard'; // Importation de BlogCard

const BlogPost = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await fetch(`https://www.googleapis.com/blogger/v3/blogs/${process.env.REACT_APP_BLOG_ID}/posts?key=${process.env.REACT_APP_API_KEY}`);
        const data = await response.json();
        setArticles(data.items || []); // Assurez-vous que 'items' est défini
      } catch (error) {
        console.error('Error fetching articles:', error);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div>
      {articles.length > 0 ? (
        articles.slice(0, 4).map((article) => ( // Limite à 4 articles
          <BlogCard key={article.id} article={article} />
        ))
      ) : (
        <p>No articles available</p>
      )}
    </div>
  );
};

export default BlogPost;
